import React from 'react';
import { Accordion as BsAccordion } from 'react-bootstrap5';

const Accordion = props => {
  const { itemKey, defaultActiveKeys, alwaysOpen, headerContent, bodyContent } = props;

  return (
    <BsAccordion defaultActiveKey={defaultActiveKeys} alwaysOpen={alwaysOpen}>
      <BsAccordion.Item eventKey={itemKey}>
        <BsAccordion.Header>{headerContent}</BsAccordion.Header>
        <BsAccordion.Body>{bodyContent}</BsAccordion.Body>
      </BsAccordion.Item>
    </BsAccordion>
  );
};

export default Accordion;
